/***
 *
 *   NOTIFICATION STYLES
 *   The reference uses sonner, configured in
 *   ui-reference/src/components/ui/sonner.tsx as top-right, `richColors`, with
 *   `bg-surface text-text-primary border border-border` on the toast and
 *   `text-text-secondary` on the description.
 *
 *   Two formats are kept because the app uses both: `toast` (the reference's
 *   shape) and the full-width `banner` that predates it.
 *
 **********/

const Style = {
    // -- toast: the reference's shape --------------------------------------
    toast: `fixed right-4 top-4 z-[9999] flex w-[22rem] max-w-[calc(100vw-2rem)] items-start gap-3 rounded-lg border
    border-border bg-surface p-4 text-left text-text-primary shadow-lg
    motion-safe:transition-all motion-safe:duration-200 motion-safe:ease-out`,
    toastEnter: 'translate-x-0 opacity-100',
    toastExit: 'translate-x-4 opacity-0',

    // richColors equivalent — a left rule carrying the status colour.
    toastSuccess: 'border-l-4 border-l-success',
    toastWarning: 'border-l-4 border-l-warning',
    toastError: 'border-l-4 border-l-error',
    toastInfo: 'border-l-4 border-l-info',

    // -- banner: full-width, kept from the previous implementation ----------
    banner: `fixed inset-x-0 top-0 z-[9999] flex items-center justify-center gap-3 px-4 py-3 text-center text-white
    motion-safe:transition-transform motion-safe:duration-200 motion-safe:ease-out`,
    bannerEnter: 'translate-y-0',
    bannerExit: '-translate-y-full',
    bannerSuccess: 'bg-success',
    bannerWarning: 'bg-warning',
    bannerError: 'bg-error',
    bannerInfo: 'bg-info',

    text: 'min-w-0 flex-1 text-sm leading-snug',
    icon: 'mt-0.5 shrink-0',
    close: `shrink-0 rounded-sm opacity-70 transition-opacity hover:opacity-100
    focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring`,
};

export default Style;
